
import { preventModalScroll, allowModalScroll } from './utils/scroll-prevention.js';

function setup3DMouseEffect(container) {
  let isHovering = false;

  container.addEventListener('mouseenter', (e) => {
    isHovering = true;
    container.style.transition = 'all 0.1s ease-out';
  });

  container.addEventListener('mouseleave', (e) => {
    isHovering = false;
    container.style.transition = 'all 0.4s ease-out';

    resetTransform(container);
  });

  container.addEventListener('mousemove', (e) => {
    if (!isHovering) return;

    const rect = container.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    const mouseX = (e.clientX - centerX) / (rect.width / 2);
    const mouseY = (e.clientY - centerY) / (rect.height / 2);

    const baseWidth = 300;
    const baseTilt = 1;
    const scaledTilt = (baseWidth / rect.width) * baseTilt;
    const maxTilt = Math.max(1, Math.min(5, scaledTilt));

    const tiltX = mouseY * maxTilt;
    const tiltY = -mouseX * maxTilt;

    container.style.setProperty('--card-tilt-x', `${tiltX}deg`);
    container.style.setProperty('--card-tilt-y', `${tiltY}deg`);
    container.style.setProperty('--card-translate-z', '10px');
    container.style.setProperty('--card-z-index', '50');
  });
}

function resetTransform(container) {
  container.style.removeProperty('--card-tilt-x');
  container.style.removeProperty('--card-tilt-y');
  container.style.removeProperty('--card-translate-z');
  container.style.removeProperty('--card-z-index');
}

function expandImage(container) {
  const modal = document.getElementById('card-modal');
  const modalImage = document.getElementById('modal-image');
  const teamMemberImg = container.querySelector('.team-member-img');

  if (!modal || !modalImage || !teamMemberImg) return;

  modalImage.src = teamMemberImg.src;
  modalImage.alt = teamMemberImg.alt;

  preventModalScroll();

  modal.style.display = 'flex';
  modal.setAttribute('aria-hidden', 'false');
  modalImage.focus({ preventScroll: true });

  const closeModal = () => {
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');

    allowModalScroll();

    container.focus({ preventScroll: true });

    modal.removeEventListener('click', closeModal);
    if (closeButton) {
      closeButton.removeEventListener('click', closeModal);
    }
    document.removeEventListener('keydown', handleKeydown);
  };

  const handleKeydown = (e) => {
    if (e.key === 'Escape') {
      closeModal();
    }
  };

  const closeButton = modal.querySelector('.card-modal-close');

  modal.addEventListener('click', closeModal);
  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }
  document.addEventListener('keydown', handleKeydown);
}

function initializeShowMore(card) {
    const bio = card.querySelector('.team-member-bio');
    if (!bio) return;

    const lineHeight = parseFloat(window.getComputedStyle(bio).lineHeight);
    const maxHeight = 10 * lineHeight;

    if (bio.scrollHeight > maxHeight) {
        bio.classList.add('truncated');
        bio.style.maxHeight = `${maxHeight}px`;

        const showMoreButton = document.createElement('button');
        showMoreButton.innerText = '+ Show More';
        showMoreButton.classList.add('show-more-button');
        bio.after(showMoreButton);

        showMoreButton.addEventListener('click', () => {
            if (bio.classList.contains('truncated')) {
                bio.classList.remove('truncated');
                bio.style.maxHeight = `${bio.scrollHeight}px`;
                showMoreButton.innerText = '- Show Less';
            } else {
                bio.classList.add('truncated');
                bio.style.maxHeight = `${maxHeight}px`;
                showMoreButton.innerText = '+ Show More';
            }
        });
    }
}

export function initializeTeamMemberImages() {
  const teamMembersSection = document.querySelector('.team-members-section');
  if (!teamMembersSection) return;

  const teamMemberCards = document.querySelectorAll('.team-member-card');
  teamMemberCards.forEach(card => {
    const container = card.querySelector('.team-member-img-container');
    if(container){
        setup3DMouseEffect(container);

        container.addEventListener('click', () => expandImage(container));
        container.setAttribute('tabindex', '0');
        container.setAttribute('role', 'button');
        container.setAttribute('aria-label', 'View team member photo in fullscreen');

        container.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                expandImage(container);
            }
        });
    }
    initializeShowMore(card);
  });
}
